import { createContext } from "react";

export const PromptContext = createContext<{setIsDataChanged: React.Dispatch<React.SetStateAction<boolean>>, isDataChanged: boolean} | null>(null);